import { LocationProvider } from '@reach/router';

// Reach Router 1.3.4 defers location updates through requestAnimationFrame.
// React 18's createRoot can leave that update pending, so navigation changes the
// URL without updating the rendered route. Reach Router is no longer maintained;
// update its provider synchronously until this app can migrate routers.
LocationProvider.prototype.componentDidMount = function componentDidMount() {
  const { refs } = this.state;
  const { history } = this.props;

  history._onTransitionComplete();
  refs.unlisten = history.listen(() => {
    if (!this.unmounted) {
      this.setState(() => ({ context: this.getContext() }));
    }
  });
};

// refs.unlisten starts as null and is only assigned in componentDidMount, which
// React skips when the commit phase aborts. Reach Router calls it unguarded, so
// the resulting "not a function" TypeError replaces whatever error aborted the
// commit, and the real failure never reaches an error boundary.
LocationProvider.prototype.componentWillUnmount =
  function componentWillUnmount() {
    const { refs } = this.state;

    this.unmounted = true;
    if (typeof refs.unlisten === 'function') {
      refs.unlisten();
    }
  };
